const IS_DEV = process.env.NODE_ENV === "development";
const IS_PROD = process.env.NODE_ENV === "production";

const reportedKeys = new Set<string>();

type MissingKeyContext = {
    key: string;
    component: string;
    lang: string;
};

export function reportMissingKey(ctx: MissingKeyContext): void {
    const dedupeId = `${ctx.lang}:${ctx.component}:${ctx.key}`;
    if (reportedKeys.has(dedupeId)) {
        return;
    }

    reportedKeys.add(dedupeId);

    if (IS_DEV) {
        console.warn(
            `[i18n] Missing translation key\n` +
            `  key:       "${ctx.key}"\n` +
            `  component: "${ctx.component}"\n` +
            `  lang:      "${ctx.lang}"`,
        );
        return;
    }

    if (IS_PROD) {
        /* Раскомментировать при подключении Sentry.
        import * as Sentry from "@sentry/nextjs";
        Sentry.captureMessage(`[i18n] Missing key: ${ctx.component}.${ctx.key} (${ctx.lang})`, {
            level: "warning",
            tags: { i18n_key: ctx.key, i18n_component: ctx.component, lang: ctx.lang },
        });
        */
    }
}
